module.exports = {
      id: "date-usage",
      viewBox: "0 0 17 16",
      url: __webpack_public_path__ + "img/icons.56e2db0a.svg#date-usage",
      toString: function () {
        return this.url;
      }
    }